export default __webpack_public_path__ + "static/media/tuhfahHome2.2cb78a3a.png";